export const SectionLabel = ({ children, className = "", light = false }) => (
  <div
    className={`mb-4 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.22em] ${
      light ? "text-white/60" : "text-brand-muted"
    } ${className}`}
  >
    <span className={`h-px w-8 ${light ? "bg-white/40" : "bg-brand-red"}`} />
    {children}
  </div>
);
